import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingKochi from "../components/blogs/DigitalMarketingKochi";

const DigitalMarketingAgencyKochi = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Agency in Kochi | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Grow your business with a reliable digital marketing agency in Kochi. SMS ZOO ZOO offers SEO, paid ads, and complete growth solutions."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-kochi"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingKochi />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyKochi;
